import React from 'react';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { Box } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { toggleFavoriteThunk } from '@/store/thunks/favoriteThunk/favoriteThunk';
import { BuilderProduct } from '@/store/builderSlice';
interface ProductFavoriteButtonProps {
    eachProduct: BuilderProduct;
    fontSize?: string;
}
const ProductFavoriteButton: React.FC<ProductFavoriteButtonProps> = ({ eachProduct, fontSize = '20px' }) => {
    const dispatch = useDispatch()
    const favoritedProduct = useSelector((state: any) => state.favorite.products[eachProduct.productId])
    function handleFavorite() {
        dispatch(toggleFavoriteThunk({ postData: { itemId: eachProduct.productId, isFavorite: favoritedProduct?.isFavorite, type: 'product', itemAdditionalData: eachProduct } }) as any);
    }
    return (
        <Box component='div'>
            {!favoritedProduct?.isFavorite && <FavoriteBorderIcon onClick={handleFavorite} sx={{ fontSize, cursor: 'pointer', color: '#000' }} />}
            {favoritedProduct?.isFavorite && <FavoriteIcon onClick={handleFavorite} sx={{ fontSize, cursor: 'pointer', color: '#FE6526' }} />}
        </Box>
    );
};
export default ProductFavoriteButton;